import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import EditLink from "@/components/EditLink.vue";
import { Routes } from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSection',
  props: {
    pink: { type: Boolean, default: false },
    title: {},
    editStep: { default: undefined },
    rows: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["profile-section relative p-9", {
      'border-green-1': !_ctx.pink,
      'border-pink-1': _ctx.pink,
      'pr-20': _ctx.editStep,
      'xl:grow xl:flex': !_ctx.rows,
    }])
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(["text-heading-lg mb-8 break-normal", {
        'text-green-1': !_ctx.pink,
        'text-pink-1': _ctx.pink,
        'xl:mb-0 xl:w-1/2 xl:pr-8 2xl:pr-1/4': !_ctx.rows,
      }])
    }, _toDisplayString(_ctx.title), 3),
    _createElementVNode("div", {
      class: _normalizeClass({ 'xl:mb-0 xl:w-1/2': !_ctx.rows })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    (_ctx.editStep)
      ? (_openBlock(), _createBlock(EditLink, {
          key: 0,
          "edit-step": _ctx.editStep,
          route: _unref(Routes).PROFILE_EDIT
        }, null, 8, ["edit-step", "route"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})